import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

import { weekStartSunday } from 'config/CustomEnums';
import { BaseHelper } from 'services/BaseGraphQLAPIHelper';

export const getMetricTableConfig = () => {
  const query = `
    query MetricTableConfigAndLevel {
      metricsTableConfig {
        pk
        metricsTableConfig
      }
      levels(first: 100, orderBy: "levelRank") {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          cursor
          node {
            id
            pk
            levelRank
            levelName
            targetTotalPointsEarned
          }
        }
      }
    }
  `;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const updateMetricTableConfig = (configString) => {
  const query = `
    mutation UpdateMetricsTableConfig($input: UpdateMetricTableConfigInput!) {
      updateMetricsTableConfig(input: $input) {
        success
        clientMutationId
        node {
          pk
          metricsTableConfig
        }
        errors {
          field
          messages
        }
      }
    }
  `;
  const variables = {
    input: {
      metricsTableConfig: configString ?? '{}',
    },
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getAllMetricTable = ({
  selectedLevelIds,
  selectedStoreIds,
  startDates,
  endDates,
}) => {
  const query = `
    query MetricsTables(
      $stores: [Int!]
      $levels: [Int!]
      $start_dates: [Date!]
      $end_dates: [Date!]
    ) {
      metricsTables(
        stores: $stores
        levels: $levels
        startDates: $start_dates
        endDates: $end_dates
      ) {
        tables {
          storeName
          metrics {
            startDate
            endDate
            netSales
            soldQuantity
            numberOfTransaction
            avgTransactionValue
            unitPreTransaction
            avgUnitRetail
          }
        }
      }
    }
  `;
  const variables = {
    start_dates: startDates,
    end_dates: endDates,
    stores: selectedStoreIds ?? [],
    levels: selectedLevelIds ?? [],
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const calculateTimeRange = ({
  timeRangeType,
  timeRangeCustomStart,
  timeRangeCustomEnd,
  timeRangeLastType,
  timeRangeToDateType,
  timeRangeWeekX,
  timeRangeWeekYear,
  timeRangePeriodStartDate,
  timeRangePeriodEndDate,
  timeRangePeriodLastType,
}) => {
  console.log(
    '🚀 ~ MetricTableAPIHelper.js:69 ~ calculateTimeRange ~ timeRangeType:',
    timeRangeType,
    timeRangeLastType,
    timeRangeToDateType,
    timeRangeWeekX,
    timeRangeWeekYear,
    timeRangePeriodStartDate,
    timeRangePeriodLastType,
  );
  const nowDay = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
  if (timeRangeType === 0) {
    return {
      start: moment(timeRangeCustomStart).toDate(),
      end: moment(timeRangeCustomEnd).toDate(),
    };
  }
  if (timeRangeType === 1) {
    if (timeRangeLastType === 0) {
      const start = moment().subtract(1, 'days');
      const end = moment();
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
    if (timeRangeLastType === 1) {
      const days = weekStartSunday ? 1 : 0;
      const start = moment()
        .startOf('isoWeek')
        .subtract(7 + days, 'days');
      const end = moment()
        .startOf('isoWeek')
        .subtract(0 + days, 'days');
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
    if (timeRangeLastType === 2) {
      const start = moment()
        .startOf('months')
        .subtract(1, 'days')
        .startOf('months');
      const end = moment().startOf('months');
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
    if (timeRangeLastType === 3) {
      const start = moment()
        .startOf('quarters')
        .subtract(1, 'days')
        .startOf('quarters');
      const end = moment().startOf('quarters');
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
    if (timeRangeLastType === 4) {
      const start = moment()
        .startOf('years')
        .subtract(1, 'days')
        .startOf('years');
      const end = moment().startOf('years');
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
  }
  if (timeRangeType === 2) {
    if (timeRangeToDateType === 0) {
      const days = weekStartSunday ? 1 : 0;
      const start = moment().startOf('isoWeek').subtract(days, 'days');
      const end = moment();
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
    if (timeRangeToDateType === 1) {
      const start = moment().startOf('months');
      const end = moment();
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
    if (timeRangeToDateType === 2) {
      const start = moment().startOf('years');
      const end = moment();
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
  }
  if (timeRangeType === 3) {
    const days = weekStartSunday ? 1 : 0;
    const weekString = `${timeRangeWeekX}`.padStart(2, '0');
    const start = moment(`${timeRangeWeekYear}-W${weekString}`).subtract(
      days,
      'days',
    );
    if (start.isValid()) {
      return {
        start: start.toDate(),
        end: start.add(7, 'days').toDate(),
      };
    }
  }
  if (timeRangeType === 4) {
    if (timeRangePeriodLastType === 0) {
      const start = moment(timeRangePeriodStartDate).subtract(1, 'days');
      const end = moment(timeRangePeriodEndDate).subtract(1, 'days');
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
    if (timeRangePeriodLastType === 1) {
      const start = moment(timeRangePeriodStartDate)
        .subtract(7, 'days');
      const end = moment(timeRangePeriodEndDate)
        .subtract(7, 'days');
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
    if (timeRangePeriodLastType === 2) {
      const start = moment(timeRangePeriodStartDate)
        .subtract(1, 'months');
      const end = moment(timeRangePeriodEndDate)
        .subtract(1, 'months');
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
    if (timeRangePeriodLastType === 3) {
      const start = moment(timeRangePeriodStartDate)
        .subtract(1, 'quarters');
      const end = moment(timeRangePeriodEndDate)
        .subtract(1, 'quarters');
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
    if (timeRangePeriodLastType === 4) {
      const start = moment(timeRangePeriodStartDate)
        .subtract(1, 'years');
      const end = moment(timeRangePeriodEndDate)
        .subtract(1, 'years');
      return {
        start: start.toDate(),
        end: end.toDate(),
      };
    }
  }
  return {
    start: null,
    end: null,
  };
};

export const formatTimeRangeConfigDict = (config) => {
  const { timeRangeType } = config;
  let newConfig = {
    name: config.name,
    hash: config?.hash ?? uuidv4(),
    timeRangeType,
  };
  if (timeRangeType === 0) {
    newConfig.timeRangeCustomStart = config.timeRangeCustomStart;
    newConfig.timeRangeCustomEnd = config.timeRangeCustomEnd;
  }
  if (timeRangeType === 1) {
    newConfig.timeRangeLastType = config.timeRangeLastType;
  }
  if (timeRangeType === 2) {
    newConfig.timeRangeToDateType = config.timeRangeToDateType;
  }
  if (timeRangeType === 3) {
    newConfig.timeRangeWeekX = config.timeRangeWeekX;
    newConfig.timeRangeWeekYear = config.timeRangeWeekYear;
  }
  if (timeRangeType === 4) {
    newConfig.timeRangePeriodLastType = config.timeRangePeriodLastType;
    newConfig.timeRangePeriodLastHash = config.timeRangePeriodLastHash;
  }
  return newConfig;
};
